import { z } from 'zod';
import { PAYMENT_PROVIDER } from '../constants/constants';
import { AcknowledgeRequest, PAYMENT_STATUS, StripePlan } from '../typesAndInterfaces/typesAndInterfaces';
import { StripePlanObj } from '../utils/zod/zodObjects';
import { axiosCaller } from './customAxios';

const paymentAndOrdersApiCalls = {
    acknowledgePurchase: async (requestParams: AcknowledgeRequest<PAYMENT_PROVIDER>): Promise<PAYMENT_STATUS> => {
        return await axiosCaller({
            path: '/api/paymentAndOrders/acknowledgePurchase',
            method: 'post',
            responseValidatorObj: z.nativeEnum(PAYMENT_STATUS),
            responseFormatValidatorMessage: 'Data mismatch for acknowledge purchase',
            responseDataKey: 'paymentStatus',
            data: requestParams,
            passToken: true,
        });
    },
    checkPaymentStatus: async (): Promise<PAYMENT_STATUS> => {
        return await axiosCaller({
            path: '/api/paymentAndOrders/checkPaymentStatus',
            method: 'post',
            responseValidatorObj: z.nativeEnum(PAYMENT_STATUS),
            responseFormatValidatorMessage: 'Data mismatch for check payment status',
            responseDataKey: 'paymentStatus',
            passToken: true,
        });
    },

    // ---- Stripe (web) subscriptions ------------------------------------------
    getStripePlans: async (): Promise<StripePlan[]> => {
        return await axiosCaller({
            path: '/api/paymentAndOrders/stripe/plans',
            method: 'get',
            responseValidatorObj: z.array(StripePlanObj),
            responseFormatValidatorMessage: 'Data mismatch for Stripe plans',
            responseDataKey: 'plans',
            passToken: true,
        });
    },
    createStripeCheckoutSession: async (productId: string): Promise<string> => {
        return await axiosCaller({
            path: '/api/paymentAndOrders/stripe/createCheckoutSession',
            method: 'post',
            responseValidatorObj: z.string(),
            responseFormatValidatorMessage: 'Data mismatch for Stripe checkout session',
            responseDataKey: 'url',
            data: { productId },
            passToken: true,
        });
    },
    syncStripeCheckoutSession: async (sessionId: string): Promise<PAYMENT_STATUS> => {
        return await axiosCaller({
            path: '/api/paymentAndOrders/stripe/syncCheckoutSession',
            method: 'post',
            responseValidatorObj: z.nativeEnum(PAYMENT_STATUS),
            responseFormatValidatorMessage: 'Data mismatch for Stripe checkout sync',
            responseDataKey: 'paymentStatus',
            data: { sessionId },
            passToken: true,
        });
    },
    createStripePortalSession: async (): Promise<string> => {
        return await axiosCaller({
            path: '/api/paymentAndOrders/stripe/createPortalSession',
            method: 'post',
            responseValidatorObj: z.string(),
            responseFormatValidatorMessage: 'Data mismatch for Stripe portal session',
            responseDataKey: 'url',
            passToken: true,
        });
    },
};

export { paymentAndOrdersApiCalls };
